import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';

@Component({
  selector: 'kt-reactive-form-layout',
  templateUrl: './reactive-form-layout.component.html',
  styleUrls: ['./reactive-form-layout.component.scss']
})
export class ReactiveFormLayoutComponent implements OnInit, OnChanges {

  form: FormGroup;
  @Input() options: any;
  @Input() values: any;
  @Input() fieldList: any;
  @Input() isLoading = true;
  // tslint:disable-next-line:no-inferrable-types
  @Input() formConfigrations: any = '';
  @Output() submitForm = new EventEmitter();
  @Output() valueChange = new EventEmitter<any>();

  constructor(public location: Location) { }
  ngOnInit() {
    const formGroup = {};
    for (const field of this.fieldList) {
      for (const subfield of field.fields) {
        if (subfield.required) {
          formGroup[subfield.key] = new FormControl(this.values[subfield.key] || null, Validators.required);
        } else {
          formGroup[subfield.key] = new FormControl(this.values[subfield.key] || null);
        }
      }
    }
    this.form = new FormGroup(formGroup);
  }

  onSubmit(value, isValid) {
    if (isValid) {
      this.submitForm.emit(value);
    }
  }

  onValueChange(event) {
    this.valueChange.emit(event);
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log("FORM-COMPO : ", changes);
  }
}
